

export const transformOptions = (months, forecastData, selectedProduct) => {
    const forecastDataByProduct = forecastData?.month?.[selectedProduct]?.months || {};

    return months.map(month => ({
        ...month,
        filled: forecastDataByProduct.hasOwnProperty(month.value),
    }));
};